import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ActionButtonProps } from "../../../../ActionButtons";
import Modal from "../../../../Modal";
import useStyles from "./styles";
import { CartonComment } from "../../../../../../models/carton";
import { CommentItem } from "../CommentItem";

export interface CommentsHistoryModalHandles {
  open: (sscc?: string, comments?: CartonComment[]) => void;
  close: () => void;
}
interface CommentModalProps {
  closeModal?: () => void;
  onDeleteComment: (sscc: string, comments: CartonComment[]) => void;
}

const CommentsHistoryModal: ForwardRefRenderFunction<
  CommentsHistoryModalHandles,
  CommentModalProps
> = (props, ref) => {
  const classes = useStyles();
  const { closeModal, onDeleteComment } = props;
  const { t: translate } = useTranslation();

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [comments, setComments] = useState<CartonComment[]>();
  const [sscc, setSscc] = useState<string>();

  const open = useCallback((sscc?: string, comments?: CartonComment[]) => {
    setOpenModal(true);
    setComments(comments);
    setSscc(sscc);
  }, []);
  const close = useCallback(() => {
    setOpenModal(false);
    setComments([]);
    setSscc("");
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  const onClose = () => {
    if (closeModal) closeModal();
    close();
  };

  const handleDeleteComment = (index: number) => {
    if (!sscc) return;
    setComments((comments) => {
      const clonedComments = [...(comments ?? [])];
      clonedComments?.splice(index, 1);
      onDeleteComment(sscc, clonedComments ?? []);
      return clonedComments;
    });
  };

  const actionButtonProps: ActionButtonProps = {
    showCancelButton: false,
    showSaveButton: false,
  };

  return (
    <Modal
      title={translate("commentsHistory")}
      open={openModal}
      handleClose={onClose}
      className={classes.paper}
      showActionButtons
      actionButtonProps={actionButtonProps}
    >
      <Grid container direction="row">
        {comments?.map((comment, index) => (
          <CommentItem
            key={index}
            comment={comment}
            handleDeleteComment={() => handleDeleteComment(index)}
          />
        ))}
      </Grid>
    </Modal>
  );
};

export default forwardRef(CommentsHistoryModal);
